<template>
  <div>
    <label :for="handle">{{ label }}</label>
    <div class="input-group">
      <input type="number" class="form-control" autocomplete="off"
             :placeholder="placeholder"
             :class="inputClass"
             v-model="newValue"
             v-on:keyup="emitKeyup"
             v-on:input="emitInput">
    </div>
  </div>
</template>
<style></style>
<script>
export default {
  name: "filter-criteria-number",
  props: {
    label: String,
    handle: String,
    inputClass: String,
    placeholder: String,
    value: [ String, Boolean ]
  },
  methods: {
    emitInput () {
      this.$emit('input', this.newValue)
    },
    emitKeyup (e) {
      this.$emit('keyup', e)
    }
  },
  data: function () {
    return {
      newValue: false,
    }
  },
  mounted() {
    this.newValue = this.value;
  }
}
</script>
